/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Direction_SalesInputs */

const en_reference_direction_sales = /** @type {(inputs: Reference_Direction_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales`)
};

/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Reference_Direction_SalesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_direction_sales = /** @type {((inputs?: Reference_Direction_SalesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Direction_SalesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_direction_sales(inputs)
});